export default {
      id: "i-menu-phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-phone",
      toString: function () {
        return this.url;
      }
    }